import { useId } from 'react'
import { useFilterPanel } from './FilterPanelContext'

export interface RadioOption {
    value: string
    label: string
}

interface Props {
    name: string
    label: string
    options: RadioOption[]
}

/**
 * Radio-button section for the filters panel (Figma 7403-41874).
 * Exclusive selection with a per-section "Limpiar" action. Reads/writes its
 * value through the FilterPanel context.
 */
export const FilterRadioGroup = ({ name, label, options }: Props) => {
    const { values, setValue, clearValue } = useFilterPanel()
    const groupId = useId()
    const selected = (values[name] as string) ?? ''

    return (
        <div className="flex flex-col gap-[4px] w-full">
            <div className="flex items-center justify-between">
                <span className="text-[14px] leading-[18px] text-[#3E5060]">{label}</span>
                {selected && (
                    <button
                        type="button"
                        onClick={() => clearValue(name)}
                        className="text-[14px] leading-[18px] font-semibold text-[#568C13] hover:text-green-700"
                    >
                        Limpiar
                    </button>
                )}
            </div>

            <div className="flex items-center gap-[34px]">
                {options.map((opt) => {
                    const checked = selected === opt.value
                    const id = `${groupId}-${opt.value}`
                    return (
                        <label key={opt.value} htmlFor={id} className="flex items-center gap-[8px] cursor-pointer">
                            <input
                                id={id}
                                type="radio"
                                name={groupId}
                                checked={checked}
                                onChange={() => setValue(name, opt.value)}
                                className="sr-only"
                            />
                            <span
                                aria-hidden="true"
                                className={`flex items-center justify-center w-6 h-6 rounded-full border-2 shrink-0 ${
                                    checked ? 'border-[#568C13]' : 'border-[#CBD5E1]'
                                }`}
                            >
                                {checked && <span className="w-3 h-3 rounded-full bg-[#568C13]" />}
                            </span>
                            <span className="text-[14px] leading-[18px] font-medium text-[#3E5060] whitespace-nowrap">{opt.label}</span>
                        </label>
                    )
                })}
            </div>
        </div>
    )
}
